import * as React from 'react'

import { GlobalStripBanner } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { StripBanner } from '@thg-commerce/gravity-patterns'

import { BaseWidgetProps } from '../types'

export type StripBannedRendererProps = BaseWidgetProps &
  Omit<GlobalStripBanner, 'query'>

export const StripBannerRenderer = (props: StripBannedRendererProps) => {
  return (
    <StripBanner
      stripBannerURL={props.stripBannerURL || undefined}
      stripBannerText={props.stripBannerText || undefined}
      hideDefaultBanner={props.hideDefaultBanner === 'true'}
    />
  )
}
